import { isProductionEnvironment } from '../../../../utility/environments';

export const coopDevToolsAvailable = !isProductionEnvironment;
